import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RejectImportToOrganisationRequestMutationVariables = Types.Exact<{
  inviteId: Types.Scalars['ID']['input'];
}>;


export type RejectImportToOrganisationRequestMutation = { __typename?: 'Mutation', rejectAddToOrganisationRequest: boolean };


export const RejectImportToOrganisationRequestDocument = gql`
    mutation RejectImportToOrganisationRequest($inviteId: ID!) {
  rejectAddToOrganisationRequest(requestId: $inviteId)
}
    `;
export type RejectImportToOrganisationRequestMutationFn = Apollo.MutationFunction<RejectImportToOrganisationRequestMutation, RejectImportToOrganisationRequestMutationVariables>;

/**
 * __useRejectImportToOrganisationRequestMutation__
 *
 * To run a mutation, you first call `useRejectImportToOrganisationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectImportToOrganisationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectImportToOrganisationRequestMutation, { data, loading, error }] = useRejectImportToOrganisationRequestMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRejectImportToOrganisationRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectImportToOrganisationRequestMutation, RejectImportToOrganisationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectImportToOrganisationRequestMutation, RejectImportToOrganisationRequestMutationVariables>(RejectImportToOrganisationRequestDocument, options);
      }
export type RejectImportToOrganisationRequestMutationHookResult = ReturnType<typeof useRejectImportToOrganisationRequestMutation>;
export type RejectImportToOrganisationRequestMutationResult = Apollo.MutationResult<RejectImportToOrganisationRequestMutation>;
export type RejectImportToOrganisationRequestMutationOptions = Apollo.BaseMutationOptions<RejectImportToOrganisationRequestMutation, RejectImportToOrganisationRequestMutationVariables>;